export default __webpack_public_path__ + "static/media/cityImg.78c0a457.png";